import React from 'react';
import { observer } from 'mobx-react';
import { DeckUI } from '@seedlang/state';
import ConceptDescription from './concept_description';

@observer
class TenseDescription extends React.Component {

  render() {
    return (
      <ConceptDescription
        concept={DeckUI.currentCard.concept}
      />
    );
  }
}

export default TenseDescription;
